import classNames from "classnames";
import isNumber from "lodash/isNumber";
import isString from "lodash/isString";
import { Label } from "PFComponents/label";
import { ReactElement, ReactNode } from "react";

import { Flex } from "../containers";
import { Typography } from "../typography";

type ReadOnlyFieldProps = {
  label: string;
  required?: boolean;
  value: string | number | ReactElement<any>;
  clipOverflow?: boolean;
  inline?: boolean;
  classes?: {
    root?: string;
    value?: string;
  };
};

const isPrintable = (value: ReactNode) => isString(value) || isNumber(value);

export const ReadOnlyField = ({
  label,
  required,
  value,
  clipOverflow,
  inline,
  classes
}: ReadOnlyFieldProps) => (
  <Flex
    as="span"
    direction="column"
    {...(inline && { direction: "row", alignItems: "center", gap: "spacingSm" })}
    className={classNames(classes?.root)}
    title={isPrintable(label) && isPrintable(value) ? `${label}: ${value}` : undefined}
  >
    <Label text={label} variant={inline ? "bodyRegular" : "labelRegular"} required={required} />
    <Typography
      className={classNames(classes?.value)}
      variant="bodyBold"
      tag="span"
      textOverflow={clipOverflow && isPrintable(value) ? "clip" : undefined}
    >
      {isPrintable(value) ? String(value) : value}
    </Typography>
  </Flex>
);
